/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';

import { CreateWindowsLocalAccessUserComponent } from './create-windows-local-access-user.component';

@NgModule({
    declarations: [CreateWindowsLocalAccessUserComponent],
    exports: [CreateWindowsLocalAccessUserComponent],
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class CreateWindowsLocalAccessUserModule { }
